import script from "./GoogleAuthButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleAuthButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleAuthButton.vue?vue&type=style&index=0&id=f9e2779c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9e2779c"]])

export default __exports__